import React from 'react'
import TransactionCompanDetail from '../../Components/RETransactionAdvisor/ReTransactionDatailPage/TransactionCompanyDetail'
import RefineSearch from '../../Components/RefineSearchComponent' 
import Card from '../../Components/RE/ReListCard/AdvisorDetailcard'
import ReLayout from '../../Components/ReLayout'
import Constants from '../../Constants'
import { routeNames } from '../../routeSegments'
import ReAdvisorRefineSearch from '../../Components/RefineSearch/ReAdvisorRefineSearch'
import ReInvestorExitRefineSearch from '../../Components/RefineSearch/ReInvestorExitRefineSearch'


import { useSearchParams } from 'react-router-dom'
/**
 * The ReTransactionDetail function is a React component that renders a layout for displaying
 * transaction details, including a card component and a section for displaying transaction company
 * details.
 * @returns The ReTransactionDetail component is being returned.
 */
const ReTransactionDetail = () => {
    const[URLSearchParams, SetURLSearchParams] = useSearchParams({section:Constants.primaryMasterSubIds.re_transaction_investment_id})
    const section = parseInt(URLSearchParams.get('section'))
  return (
    <div>
    <ReLayout>
    <div className="flex h-screen flex-col">
            {/* <Card DEATAILPAGE_CARD={DEATAILPAGE_CARD}/> */}
            <Card/>
            <div className="flex min-h-0 flex-1 overflow-hidden bg-[#EDEDED] ">
                {/* Primary column */}
                <section
                    aria-labelledby="primary-heading"
                    className="flex h-full min-w-0 flex-1 flex-col overflow-y-auto lg:order-last">
                    {/* <CompanyDetail COMPANY_PROFILE={COMPANY_PROFILE}  /> */}
                    <TransactionCompanDetail  section={section}/> 
                    
                {/* <Outlet /> */}
                {/* Your content */}
                </section>
                {/* Secondary column (hidden on smaller screens) */}
                <aside className="hidden lg:order-first lg:block lg:flex-shrink-0">
                    <div className="relative flex h-full  flex-col border-r border-gray-200 bg-[#FAF5EA]">
                        {/* Your content */} 
                              <RefineSearch>
                                  {
                                      section === Constants.primaryMasterSubIds.re_advisor_investment_id
                                          ? <ReAdvisorRefineSearch customPathname={routeNames.re_transaction_advisors_re_investments} />
                                          : section === Constants.primaryMasterSubIds.re_transaction_exits_id
                                              ? <ReInvestorExitRefineSearch customPathname={routeNames.re_transaction_advisors_re_exits} />
                                              : section === Constants.primaryMasterSubIds.re_transaction_otherma_id
                                                  ? <ReInvestorExitRefineSearch customPathname={routeNames.re_transaction_advisors_other_ma} />
                                                  : <ReAdvisorRefineSearch customPathname={routeNames.re_transaction_advisors_re_investments} />
                                  }
                              </RefineSearch>
                    </div>
                </aside>
            </div>
            <br/>
            
        </div>
    </ReLayout>
</div>
  )
}

export default ReTransactionDetail
